export const actionType = {
  REMOVE_TOAST: "REMOVE_TOAST",
  CHANGE_TERM: "CHANGE_TERM",

  GET_CUSTOMER_PRODUCTS: "GET_CUSTOMER_PRODUCTS",
  GET_CUSTOMER_PRODUCTS_SUCCESS: "GET_CUSTOMER_PRODUCTS_SUCCESS",
  GET_CUSTOMER_PRODUCTS_FAILED: "GET_CUSTOMER_PRODUCTS_FAILED",

  ASSIGN_CUSTOMER_PRODUCT: "ASSIGN_CUSTOMER_PRODUCT",
  ASSIGN_CUSTOMER_PRODUCT_SUCCESS: "ASSIGN_CUSTOMER_PRODUCT_SUCCESS",
  ASSIGN_CUSTOMER_PRODUCT_FAILED: "ASSIGN_CUSTOMER_PRODUCT_FAILED",

  UPDATE_CUSTOMER_PRODUCT: "UPDATE_CUSTOMER_PRODUCT",
  UPDATE_CUSTOMER_PRODUCT_SUCCESS: "UPDATE_CUSTOMER_PRODUCT_SUCCESS",
  UPDATE_CUSTOMER_PRODUCT_FAILED: "UPDATE_CUSTOMER_PRODUCT_FAILED",

  DELETE_CUSTOMER_PRODUCT: "DELETE_CUSTOMER_PRODUCT",
  DELETE_CUSTOMER_PRODUCT_SUCCESS: "DELETE_CUSTOMER_PRODUCT_SUCCESS",
  DELETE_CUSTOMER_PRODUCT_FAILED: "DELETE_CUSTOMER_PRODUCT_FAILED",

  GET_CUSTOMER_DATA: "GET_CUSTOMER_DATA",
  GET_CUSTOMER_DATA_SUCCESS: "GET_CUSTOMER_DATA_SUCCESS",
  GET_CUSTOMER_DATA_FAILED: "GET_CUSTOMER_DATA_FAILED",

  CREATE_CUSTOMER_DATA: "CREATE_CUSTOMER_DATA",
  CREATE_CUSTOMER_DATA_SUCCESS: "CREATE_CUSTOMER_DATA_SUCCESS",
  CREATE_CUSTOMER_DATA_FAILED: "CREATE_CUSTOMER_DATA_FAILED",

  UPDATE_CUSTOMER_DATA: "UPDATE_CUSTOMER_DATA",
  UPDATE_CUSTOMER_DATA_SUCCESS: "UPDATE_CUSTOMER_DATA_SUCCESS",
  UPDATE_CUSTOMER_DATA_FAILED: "UPDATE_CUSTOMER_DATA_FAILED",

  DELETE_CUSTOMER_DATA: "DELETE_CUSTOMER_DATA",
  DELETE_CUSTOMER_DATA_SUCCESS: "DELETE_CUSTOMER_DATA_SUCCESS",
  DELETE_CUSTOMER_DATA_FAILED: "DELETE_CUSTOMER_DATA_FAILED"
}

const initialState = {
  customer: null,
  links: null,
  product: null,
  metaProduct: null,
  applied_term: null,
  isLoading: false,
  error: null,
  toast: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case actionType.REMOVE_TOAST:
      return Object.assign({}, state, {
        toast: null
      })
    case actionType.CHANGE_TERM:
      return Object.assign({}, state, {
        applied_term: action.term
      })
    case actionType.ASSIGN_CUSTOMER_PRODUCT:
    case actionType.UPDATE_CUSTOMER_PRODUCT:
    case actionType.DELETE_CUSTOMER_PRODUCT:
    case actionType.GET_CUSTOMER_DATA:
    case actionType.CREATE_CUSTOMER_DATA:
    case actionType.UPDATE_CUSTOMER_DATA:
    case actionType.DELETE_CUSTOMER_DATA:
      return Object.assign({}, state, {
        isLoading: true,
        error: null,
      });
    case actionType.GET_CUSTOMER_PRODUCTS:
      return Object.assign({}, state, {
        isLoadingCustomer: true,
        error: null,
      });
    case actionType.GET_CUSTOMER_PRODUCTS_FAILED:
      return Object.assign({}, state, {
        isLoadingCustomer: false,
        error: action.error
      });

    case actionType.UPDATE_CUSTOMER_PRODUCT_FAILED:
    case actionType.DELETE_CUSTOMER_PRODUCT_FAILED:
    case actionType.GET_CUSTOMER_DATA_FAILED:
    case actionType.CREATE_CUSTOMER_DATA_FAILED:
    case actionType.UPDATE_CUSTOMER_DATA_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.error
      });
    case actionType.GET_CUSTOMER_PRODUCTS_SUCCESS:
      return Object.assign({}, state, {
        product: action.payload.data,
        metaProduct: action.payload.meta,
        isLoadingCustomer: false,
        error: null
      })
    case actionType.ASSIGN_CUSTOMER_PRODUCT_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        toast: {
          type: 'success',
          message: 'Successfully added product',
          data: 'product',
          request: 'assign-product'
        }
      })
    case actionType.ASSIGN_CUSTOMER_PRODUCT_FAILED:
      return Object.assign({}, state, {
        isLoading: false,
        error: action.payload.error,
        toast: {
          type: 'failed',
          message: action.payload.error,
          request: 'assign-product'
        }
      })
    case actionType.UPDATE_CUSTOMER_PRODUCT_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        toast: {
          type: 'success',
          message: 'Successfully updated product',
          data: 'product',
          request: 'edit-product'
        }
      })
    case actionType.DELETE_CUSTOMER_PRODUCT_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        toast: {
          type: 'success',
          message: 'Successfully deleted product',
          data: 'product',
          request: 'delete-product'
        }
      })
    case actionType.GET_CUSTOMER_DATA_SUCCESS:
      return Object.assign({}, state, {
        customer: action.payload.data,
        applied_term:
          !!action.payload.data.find(val => val.flag === 1)
            ? action.payload.data.find(val => val.flag === 1)
            : state.applied_term,
        // meta: action.payload.meta,
        links: action.payload.links,
        isLoading: false,
        error: null
      })
    case actionType.CREATE_CUSTOMER_DATA_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        toast: {
          type: 'success',
          message: 'Successfully added customer',
          data: 'customer',
          request: 'add-customer'
        }
      })
    case actionType.UPDATE_CUSTOMER_DATA_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        toast: {
          type: 'success',
          message: 'Successfully updated customer',
          data: 'customer',
          request: 'edit-customer'
        }
      })
    case actionType.DELETE_CUSTOMER_DATA_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        error: null,
        toast: {
          type: 'success',
          message: 'Successfully deleted customer',
          data: 'customer',
          request: 'delete-customer'
        }
      })
    default:
      return state;
  }
}

export const actionCreators = {
  removeToast: () => ({ type: actionType.REMOVE_TOAST }),
  changeTerm: term => ({ type: actionType.CHANGE_TERM, term }),
  getCustomers: (company_id, params) => ({
    type: actionType.GET_CUSTOMER_DATA, company_id, params
  }),
  createCustomer: (company_id, body) => ({
    type: actionType.CREATE_CUSTOMER_DATA, company_id, body
  }),
  updateCustomer: (company_id, customer_id, body) => ({
    type: actionType.UPDATE_CUSTOMER_DATA, company_id, customer_id, body
  }),
  deleteCustomer: (company_id, customer_id) => ({
    type: actionType.DELETE_CUSTOMER_DATA, company_id, customer_id
  }),
  getCustomerProduct: (customer_id, params) => ({
    type: actionType.GET_CUSTOMER_PRODUCTS, customer_id, params
  }),
  assignCustomerProduct: (customer_id, body) => ({
    type: actionType.ASSIGN_CUSTOMER_PRODUCT, customer_id, body
  }),
  updateCustomerProduct: (customer_id, product_id, body) => ({
    type: actionType.UPDATE_CUSTOMER_PRODUCT, customer_id, product_id, body
  }),
  deleteCustomerProduct: (customer_id, product_id) => ({
    type: actionType.DELETE_CUSTOMER_PRODUCT, customer_id, product_id
  })
}


// WEBPACK FOOTER //
// ./src/modules/company/pages/customer/reducer.js